<template>
  <w-flex class="form-aside w-theme--dark" direction="col" align="stretch">
    <app-logo />

    <w-flex v-if="documentTitle" class="form-aside__document-title-wrapper">
      <document-title :document-title="documentTitle" />
    </w-flex>

    <w-flex fluid direction="col" class="form-aside__tab-list w-scroll">
      <form-aside-button
        v-for="(tab, index) in tabs"
        :key="'tab_' + tab.name + '_' + index"
        :tab="tab"
        :index="index"
        :active="currentTabName == tab.name"
        @tab-selected="$emit('change-tab', tab)"
      />
    </w-flex>

    <app-version :project-name="props.projectName" :version="props.version" />
  </w-flex>
</template>

<script setup lang="ts">
import type { Tab } from '@/typings/tab';

import AppLogo from './AppLogo.vue';
import AppVersion from './AppVersion.vue';
import DocumentTitle from './DocumentTitle.vue';
import FormAsideButton from './FormAsideButton.vue';

const props = defineProps<{
  tabs: Tab[];
  version?: string;
  projectName?: string;
  documentTitle?: string;
  currentTabName: string;
}>();

defineEmits({
  'change-tab': null,
});
</script>

<style lang="scss">
.form-aside {
  background: w.color('neutral', 75);
  width: w.size('aside-width');
  flex-shrink: 0;
  flex-grow: 0;

  .form-aside-button {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  &__tab-list,
  &__document-title-wrapper {
    border-top: solid 1px w.color('neutral', 200);
  }

  hr {
    border-color: w.color('neutral', 200);
  }

  &__tab-list {
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: solid 1px w.color('neutral', 200);
    border-top: solid 1px w.color('neutral', 200);
    height: 0;
    overflow: auto;
  }

  @include w.media-xl {
    width: w.size('aside-width--xl');
  }

  @include w.media-lg {
    width: w.size('aside-width--lg');
  }

  @include w.media-md {
    width: w.size('aside-width--md');
  }
}
</style>
